<template>
	<div class="co-review" :class="'co-review--' + version">
		<div class="co-review__reviewer">
			<span class="name"
				>{{ data.reviewerName }} <VerifiedIcon></VerifiedIcon
			></span>
			<span class="date">{{ data.date }}</span>
		</div>

		<div class="co-review__data">
			<Rating :review="data"></Rating>
			<p class="text">
				{{ data.description }}
			</p>
		</div>
	</div>
</template>

<script>
// Objects
import Rating from "./Rating.vue";

// Icons
import VerifiedIcon from "@web/assets/icon/verified.svg";

export default {
	name: "Review",
	props: {
		data: {
			type: Object,
		},
		version: {
			type: String,
			default: "compact",
		},
	},
	components: {
		//Objects
		Rating,

		//Icons
		VerifiedIcon,
	},
	data: () => {
		return {};
	},
	created() {},
	methods: {},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

// .co-review {
//   padding-top: 23.5px;
//   padding-bottom: 23.5px;
//   &__wrapper {
//     .top {
//       display: flex;
//       justify-content: space-between;
//       &__details {
//       }
//       &__date {
//         color: #a5a6b1;
//       }
//     }
//     .bottom {
//       margin-top: 13px;
//     }
//   }
//   span {
//     display: flex;
//     align-items: center;
//     color: #2b3f6c;
//     font-weight: 600;
//     svg {
//       margin-left: 8px;
//     }
//   }
// }

.co-review {
	&__reviewer {
		font-weight: $f-semibold;
		display: flex;
		.name {
			display: flex;
			align-items: center;

			svg {
				margin-left: 8px;
			}
		}
		.date {
			color: $c-greydark;
		}
	}
	&__date {
		.date {
			color: $c-greydark;
		}
	}

	&--compact {
		padding: 24px 0;
		.co-review {
			&__reviewer {
				width: 100%;
				justify-content: space-between;
			}
			&__data {
				.c-rating {
					margin-top: 9px;
					margin-bottom: 14px;
				}
			}
			&__date {
				display: none;
			}
		}
	}
	&--block {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		border-bottom: $e-border;
		padding-bottom: 40px;
		margin-bottom: 32px;

		.co-review {
			&__reviewer {
				.date {
					display: none;
				}
			}

			&__data {
				max-width: 780px;
				padding-inline: 30px;

				.c-rating {
					margin-bottom: 15px;

					&__icons {
						gap: 7px;
						svg {
							width: 22px;
							height: 22px;
						}
					}
				}
			}
		}
	}
}

@media all and (max-width: 1100px) {
	.co-review {
		&--block {
			flex-direction: column;
			.co-review {
				&__reviewer {
					justify-content: space-between;
					width: 100%;

					.date {
						display: block;
					}
				}
				&__data {
					padding-inline: 0;
					width: 100%;
					max-width: none;

					.c-rating {
						margin-top: 9px;
						margin-bottom: 14px;

						&__icons {
							gap: 4px;

							svg {
								width: 15px;
								height: 15px;
							}
						}
					}
				}
				&__date {
					display: none;
				}
			}
		}
	}
}

@media all and (max-width: 600px) {
	.co-review {
		&--block {
			border-bottom: none;
			padding-bottom: 24px;
			padding-top: 24px;
			margin-bottom: 0px;
		}
	}
}
</style>
